import React from 'react'
import CouponItems from './CouponItems';
import { useBookletCoupons } from '../../context/BookletCouponsContext';
import PrintFooter from './PrintFooter';

interface PrintPageAdditionalProps {
  hasSelectedBooklet: boolean;
  couponsPerPage: number;
  bookletColor: string;
  startIndex: number;
  pageNumber?: number;
  openCouponSelection: () => void;
}

const PrintPageAdditional: React.FC<PrintPageAdditionalProps> = ({
  hasSelectedBooklet,
  couponsPerPage,
  bookletColor,
  startIndex,
  pageNumber = 2,
  openCouponSelection,
}) => {
  const {
    selectedBooklet,
    selectedCoupons,
    setSelectedCoupons,
    setSelectedCouponIndex,
    companyCategories,
  } = useBookletCoupons();

  const handleCouponSelect = (index: number) => {
    setSelectedCouponIndex(index);
    openCouponSelection();
  };

  const handleCouponRemove = (index: number) => {
    const newSelectedCoupons = [...selectedCoupons];
    newSelectedCoupons[index] = null;
    setSelectedCoupons(newSelectedCoupons);
  };

  // Only show coupons for this page (18 coupons per additional page)
  const pageCoupons = selectedCoupons.slice(startIndex, startIndex + couponsPerPage);

  return (
    <div className={`print-a4 additional-page page-${pageNumber} ${!hasSelectedBooklet ? 'no-booklet-selected' : ''}`}>
      <div className="print-additional-header">
        <h3>{selectedBooklet?.title || 'Häfte'}</h3>
      </div>
      <div className="print-a4-inner">
        <div className="company-coupons-list additional-page">
          <CouponItems
            selectedCoupons={pageCoupons}
            onCouponSelect={handleCouponSelect}
            onCouponRemove={handleCouponRemove}
            bookletColor={bookletColor}
            companyCategories={companyCategories}
            startIndex={startIndex}
            selectedBooklet={selectedBooklet}
          />
        </div>
      </div>
      <PrintFooter />
    </div>
  );
};

export default PrintPageAdditional;
